import React from 'react';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import QuestionResults from './QuestionResults';
import LineWithRingsLegend from 'js/engines/SurveyAssessment/components/Review/LineWithRingsLegend';

function AssessmentReviewDetailResults({
  assessment,
  detailHrefFor,
  filter,
  participantCohortMap,
  cohorts,
  legendFields,
  activeCohort,
  pinnedCohort,
  peekedCohort,
  onPinCohort,
  onClearPinnedCohort,
  onPeekCohort,
  onClearPeekedCohort,
  breakoutName,
}) {
  if (!assessment) {
    return null;
  }

  const legendProps = {
    fields: legendFields,
    pinnedCohort,
    peekedCohort,
    onPinCohort,
    onClearPinnedCohort,
    onPeekCohort,
    onClearPeekedCohort,
    breakoutName,
  };

  return (
    <div className="survey-review-detail">
      {(assessment.question_sets ?? []).map((qs) => (
        <Card id={qs.key} key={qs.id} tag="section">
          <CardHeader>
            <CardTitle tag="h5">{qs.name}</CardTitle>
          </CardHeader>
          <CardBody className="pt-0">
            {breakoutName || legendFields?.length > 2 ? (
              <LineWithRingsLegend {...legendProps} />
            ) : null}

            <section className="survey-review-grid">
              {(qs.questions ?? []).map((q) => (
                <QuestionResults
                  key={q.id}
                  id={`${qs.key}_${q.key}`}
                  question={q}
                  detailHref={detailHrefFor?.(q)}
                  filter={filter}
                  participantCohortMap={participantCohortMap}
                  cohorts={cohorts}
                  activeCohort={activeCohort}
                />
              ))}
            </section>
          </CardBody>
        </Card>
      ))}
    </div>
  );
}

export default AssessmentReviewDetailResults;
